import { createSlice } from "@reduxjs/toolkit";

const socialSecurityContributionSlice = createSlice({
  name: "socialSecurityContribution",
  initialState: {
    isLoading: false,
    companyList: [],
    currentCompany: null,
    currentSocialSecurityContribution: {},
  },
  reducers: {
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    setCompanyList(state, action) {
      state.companyList = action.payload;
    },
    setCurrentCompany(state, action) {
      state.currentCompany = action.payload;
    },
    setCurrentSocialSecurityContribution(state, action) {
      state.currentSocialSecurityContribution = action.payload;
    },
  },
});

export const {
  setIsLoading,
  setCompanyList,
  setCurrentCompany,
  setCurrentSocialSecurityContribution,
} = socialSecurityContributionSlice.actions;
export default socialSecurityContributionSlice.reducer;
